import React from 'react';
import ReactPlayer from 'react-player';
import { View } from 'components/basic';
import { fileAreaStyle, fileAreaWebExtra } from './styles';
import { getVideoUri, getVideoThumbnail } from './utils';

// Memoized so the player doesn't remount on every parent re-render
// (e.g. while upload progress updates).
const MemoizedPlayer = React.memo(function MemoizedPlayer(props) {
  return <ReactPlayer {...props} />;
});

// Renders a video file.
// Web-only element: `react-player` renders a web <video>/iframe under the hood.
// When porting to RN, replace with `react-native-video` or a similar native player.
function VideoPreview({ file, width, height, mediaRerender, onClick, videoProps }) {
  const thumbnail = getVideoThumbnail(file);

  return (
    <View
      style={{
        ...fileAreaStyle,
        width,
        height,
        position: 'relative'
      }}
    >
      <MemoizedPlayer
        src={getVideoUri(file)}
        width='100%'
        height='100%'
        light={
          thumbnail && (
            <img
              src={thumbnail}
              alt='Thumbnail'
              style={{ width: 'inherit', height: 'inherit', objectFit: 'cover' }}
            />
          )
        }
        {...videoProps}
        mediaRerender={mediaRerender}
      />
      {/* transparent overlay so a single click always opens the slide viewer,
          regardless of where react-player places its own controls */}
      <div
        onClick={onClick}
        style={{
          ...fileAreaWebExtra,
          position: 'absolute',
          inset: 0
        }}
      />
    </View>
  );
}

export default VideoPreview;
